var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79081 3.79081C3 4.58162 3 5.85442 3 8.4V15.6C3 18.1456 3 19.4184 3.79081 20.2092C4.58162 21 5.85442 21 8.4 21H15.6C18.1456 21 19.4184 21 20.2092 20.2092C21 19.4184 21 18.1456 21 15.6V8.4C21 5.85442 21 4.58162 20.2092 3.79081C19.4184 3 18.1456 3 15.6 3H8.4C5.85442 3 4.58162 3 3.79081 3.79081ZM17.2488 9.79923C17.5246 9.38565 17.4128 8.82687 16.9992 8.55115C16.5857 8.27544 16.0269 8.38719 15.7512 8.80077L13.0114 12.9104L12.5986 12.0846C11.9805 10.8485 10.2575 10.7412 9.49089 11.8912L6.75116 16.0008C6.47544 16.4143 6.5872 16.9731 7.00077 17.2488C7.41435 17.5246 7.97313 17.4128 8.24885 16.9992L10.9886 12.8896L11.4014 13.7154C12.0195 14.9515 13.7425 15.0588 14.5091 13.9088L17.2488 9.79923Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/Timeline.c47df9aaeb349a1172e0014408fa6bae.svg";
export { ForwardRef as ReactComponent };